<template>
  <div id="footer" v-if="data && langs" v-cloak>
    <footer class="footer-bg">
      <select v-if="env === 'dev' || env === 'qa'" class="form-control right" @change="$router.replace({'query': null})"
        :class="!isPhone ? 'language-select' : ''" v-model="language">
        <option v-for="(code, lang) in langs.misc.languagelist" :value="code" v-bind:key="code">
          &#127758; {{ lang }}
        </option>
      </select>
      <div class="clearfix" v-if="isPhone"></div>
      <a href="/">
        <img :src="require( `../assets/img/novonordisk.png`)" alt="Novo Nordisk Logotyp" class="img-footer left" />
      </a>
      <div class="footer-text" v-html="data.misc.bottomDisclaimer"></div>
    </footer>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'bottom',
  data () {
    return {
      data: null,
      langs: null,
      isPhone: isMobile,
      currentYear: new Date().getFullYear(),
      language: sessionStorage.getItem('language'),
      env: process.env.NODE_ENV
    }
  },
  methods: {},
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    }
  },
  watch: {
    language (l) {
      if (l) {
        this.language = l
        sessionStorage.setItem('language', this.language)
        location.reload()
      }
    }
  },
  async beforeMount () {
    this.langs = await request({
      query: `
      {
        misc {
          languagelist
        }
      }
      `
    })
    /* We get languagelist from DatoCMS, check if {l} in query param ?language={l}, ex: ?language=ar, is
       included in the list and then set the language to that. Otherwise we want to use swedish as
       fallback or accept the choice from dropdown that the user interacts with.
    */
    if (this.langs && Object.values(this.langs.misc.languagelist).includes(this.$route.query.language)) {
      this.language = this.$route.query.language
      sessionStorage.setItem('language', this.language)
    } else if (!sessionStorage.getItem('language')) {
      this.language = 'sv'
      sessionStorage.setItem('language', this.language)
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          misc(locale: ` + this.language + `) {
            bottomDisclaimer
          }
        }
      `
    })
    if (this.data) {
      this.data.misc.bottomDisclaimer = this.data.misc.bottomDisclaimer.replace('{currentYear}', this.currentYear)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
footer {
  position: relative !important;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  width: 100vw;
}
footer a {
  color: #aec9e6 !important;
}
footer a:hover {
  color: #89a7c6 !important;
}
footer p {
  color: #fff;
}
.footer-bg {
  background: #001965 !important;
}
.img-footer {
  height: 10vh;
  margin-right: .9vw;
}
.language-select {
  cursor: pointer;
  max-width: 10vw;
}
@media screen and (max-width: 800px) {
  footer {
    margin-top: 50px;
    padding-left: 15px;
  }
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    .footer-text {
      margin-left: 40vw;
      font-size: .8rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue